export default "__VITE_ASSET__CpqlhXu6__"